import * as types from "./types";

function dataSaved(payload) {
  return { type: types.DATA_SAVED, payload };
}

function resetDataSaved() {
  return { type: types.RESET_DATA_SAVED };
}

function fetchSearchDataAlumnos(payload) {
  return { type: types.FETCH_ALUMNOS, payload };
}

function fetchSearchDataColegios(payload) {
  return { type: types.FETCH_COLEGIOS, payload };
}

function fetchSearchDataActividades(payload) {
  return { type: types.FETCH_ACTIVIDADES, payload };
}

function resetSearchData() {
  return { type: types.RESET };
}

function resetSearchDataActividades() {
  return { type: types.RESET_SEARCH_ACTIVIDADES };
}

function resetSearchDataAlumnos() {
  return { type: types.RESET_SEARCH_ALUMNOS };
}

function fetchSearchDataEscuelasNombres(payload) {
  return { type: types.FETCH_SEARCH_ESCUELA_NOMBRES, payload };
}

function fetchSearchDataEscuelasResguardo(payload) {
  return { type: types.FETCH_SEARCH_ESCUELA_RESGUARDO, payload };
}

function fetchSearchDataEscuelasColegios(payload) {
  return { type: types.FETCH_SEARCH_ESCUELA_COLEGIOS, payload };
}

function resetSearchDataEscuelas() {
  return { type: types.RESET_SEARCH_ESCUELAS };
}

/*---*/
export {
  dataSaved,
  resetDataSaved,
  fetchSearchDataAlumnos,
  fetchSearchDataColegios,
  fetchSearchDataActividades,
  resetSearchData,
  resetSearchDataActividades,
  resetSearchDataAlumnos,
  fetchSearchDataEscuelasNombres,
  fetchSearchDataEscuelasResguardo,
  fetchSearchDataEscuelasColegios,
  resetSearchDataEscuelas
};



// WEBPACK FOOTER //
// ./src/ducks/busquedas/actions.js